import { render, staticRenderFns } from "./images.edit.vue?vue&type=template&id=19933dfa&scoped=true"
import script from "./images.edit.vue?vue&type=script&lang=js"
export * from "./images.edit.vue?vue&type=script&lang=js"
import style0 from "./images.edit.vue?vue&type=style&index=0&id=19933dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19933dfa",
  null
  
)

export default component.exports